var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.tagLabel},[_vm._v(" "+_vm._s(_vm.optInName(_vm.optInData))+" "),(_vm.optInData.hint)?_c('p',{class:_vm.$style.tagHint},[_vm._v(_vm._s(_vm.optInHint(_vm.optInData)))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }